import { makeStyles } from '~styles';

export const useTitleStyles = makeStyles()(() => {
	return {
		root: {
			margin: '10px 0',
		},
	};
});
